export default __webpack_public_path__ + "static/media/c_q.e1440cc6.svg";